import { PageHeader } from "./page-header.js"

export function PendingPage({ title, stage, what }: { title: string; stage: string; what: string }) {
  return (
    <>
      <PageHeader title={title} description={`Lands in ${stage}. ${what}`} />
      <div
        style={{
          border: "1px dashed var(--csbi-gridline)",
          borderRadius: "var(--rd-radius-card)",
          padding: "32px 24px",
          textAlign: "center",
          color: "var(--csbi-ink-muted)",
          fontSize: 13,
        }}
      >
        Not built yet — see delivery item {stage}.
      </div>
    </>
  )
}
